export default "__VITE_ASSET__BHiuJexX__"